import { useMutation } from '@tanstack/react-query'
import { goToLogin, logout } from './api'

/**
 * Session을 끊고 로그인 화면으로 돌려보낸다.
 *
 * 옮기는 일을 서버 응답이 성공했을 때만 한다. 끊지 못했는데 로그인 화면을 보이면 나간 것으로
 * 읽히지만 Session은 그대로 살아 있다.
 *
 * 캐시를 비우고 화면 안에서 경로만 바꾸는 것으로는 모자랐다. 비운 캐시를 다시 채우는 데 왕복이
 * 한 번 걸리는 동안 로그인 화면이 앞선 판정을 그대로 읽어 홈으로 되돌렸다.
 */
export function useLogout() {
  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      goToLogin()
    },
  })
}
